/**
 * Created by Languagenut on 28/08/2019.
 */

import React  from 'react';
import {FormCheck, Button , Card , Row , Col , Alert} from 'react-bootstrap'
import contentService from '../../../services/content-service.js';
import ContentStore from '../../../store/content-store.js';
import AccountStore from '../../../store/account-store.js';
import Translation from '../../../store/internationalization-store';
import Constants from '../../../constants.js';
import homeworkStore from '../../../store/homework-store.js';
import Popup from  '../../../components/popup.js';
import Checkbox from '../../checkbox.js';
import exams from '../../../classes/exams.js';

class Activity extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.isChecked = {};
        this.isExamTrigger = {};
        this.state = {
            games:[],
            currentPopout:""
        };

        this.props.data.isMake = true;
    }

    updateCheckBoxInput(event, uid) {
        this.updateChecked(uid, event.currentTarget.checked);
    }

    updateChecked(uid, isChecked) {
        this.isChecked[uid] = isChecked;
        this.setState({update:true})
    }

    showPreview(gameUid, isEnglish) {
        var languageUid = "en";
        if (isEnglish) {
            languageUid = this.props.data.language.ietf
        }
        contentService.getExamTranslation(homeworkStore.getSelectedMassData()[0]['uid'], languageUid).then(function(data) {
            var examsObject = new exams(data).generateData(gameUid);
            var mainText = examsObject[0];
            var questions = examsObject[1];
            var endText = <Popup fullHeight={true} open={true} 
                    close={function(){this.setState({currentPopout:""})}.bind(this)}>
                        <div>
                            {mainText}
                            {questions}
                </div>
            </Popup>

            this.setState({currentPopout:endText});
        }.bind(this))

    }

    getLocale(){
        return (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
    };

    game(counter){
        if (this.props.data.type == "exam") {
            var mainColor = {color:"#007bff", paddingRight:"65px", textAlign:"right"};
            var otherStyle = {};
            if (this.isExamTrigger[counter]) {
                mainColor = {paddingRight:"65px", textAlign:"right"};
                otherStyle={color:"#007bff"};
            }
            var display = "none";
            if (this.state.games[counter].isSwitcher) {
                display = "block";
            }

            var questionsInEnglish = <FormCheck custom type="switch">
                    <span style={mainColor}>{Translation.get(12694, `Questions in English`)}</span>
                    <FormCheck.Input checked={this.isExamTrigger[counter]} />
                    <FormCheck.Label style={{transform:"scale(1.5)", top:"-5px"}}
                    onClick={function() {
                        this.isExamTrigger[counter] =!this.isExamTrigger[counter]
                        this.isChecked[counter] = true;
                        this.setState({update:true});
                    }.bind(this)}>
                    </FormCheck.Label>
                    <span style={otherStyle}>{Translation.get(12695, `Questions in target language`)}</span>
                </FormCheck>
            if (this.props.data.language.ietf == "en" || this.props.data.language.ietf == "en-US") {
                questionsInEnglish = "";
            }
            

            return <Col md={12}><Card>
                    <Card.Body>
                        <Row >
                            <Col sm={{span: 4, offset: 0}}><Card.Text>
                                <i style={{paddingRight:"20px"}} onClick={()=>{
                                            this.showPreview(this.state.games[counter].uid, this.isExamTrigger[counter])
                                        }} class="hyperlink hyperlink_black fas fa-info-circle"></i>
                                {Translation.get(this.state.games[counter].title,"game")}
                                </Card.Text></Col>
                            <Col sm={{span: 6, offset: 0}}><span className="float-right" style={{display:display}}>
                                    {questionsInEnglish}
                                    
                                    </span>
                            </Col>

                            <Col  sm={{span: 1, offset: 0}}onClick={function() {
                                this.isChecked[counter] =!this.isChecked[counter]
                                this.setState({update:true});
                            }.bind(this)}><span className="float-right">
                                    <Checkbox isDisabled checked={this.isChecked[counter]}/></span>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card><br/></Col>
        } else {
            return <Col md={6}><Card>
                    <Card.Body onClick={function() {
                                this.isChecked[counter] =!this.isChecked[counter]
                                this.setState({update:true});
                            }.bind(this)}>
                        <Row >
                            <Col sm={{span: 10, offset: 0}}><Card.Text>{Translation.get(this.state.games[counter].title,"game")}</Card.Text></Col>
                            <Col sm={{span: 2, offset: 0}}><span className="float-right"> 
                                    <Checkbox isDisabled checked={this.isChecked[counter]}  type="checkbox"
                                    onChange={function(event){
                                        this.updateCheckBoxInput(event, counter)
                                    }.bind(this)}/></span>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card><br/></Col>
        } 
    }

    view(){
        let body = [];

        for(var i = 0 ; i < this.state.games.length; i++){
            body.push(this.game(i))
        }

        return body;
    }

    componentWillMount() {
        ContentStore.on(Constants.GET_ALL_VOCAB_GAMES,  ()=>{
            this.setState({
                "games":ContentStore.vocabGames
            });
        })
        ContentStore.on(Constants.GET_ALL_VERB_GAMES,  ()=>{
            if (ContentStore.verbGames.length == 1) {
                this.isChecked[0] = true;
            }
            this.setState({
                "games":ContentStore.verbGames
            });
        })
        /*
        var moduleUid = data.uid;

        contentService.getExamTranslation(data.uid).then(function(data2) {
            HomeworkStore.addToTemporaryStore(data.uid);
            HomeworkStore.addToTemporaryStore(data2);
            HomeworkStore.addToTemporaryStore(data.difficulty);
            HomeworkStore.addToTemporaryStore(this.state.breadcrumbs[this.state.breadcrumbs.length-2].title);
            HomeworkStore.addToTemporaryStore(this.exam_catalog_uid);
            this.props.forceAdvance();
        }.bind(this));
        */

    }

    checkIfVerbsAreGames(verbs){
        var currentVerbs = ["1","2","4","5","6","8","9","10","12","13","14","16","17","18","20","21","22","24","25",
                "26","28","29","30","32","33","34","36","37","38","40","41","42","44","45","46","48","49","50","52",
                "53","54","56","57","58","60","61","62","64","65","66","68","69","70","72","73","74","76","77","78","80"
                ,"81","82","84","85","86","88","89","90","92","93","94","96","100","101","105","106","110","111","115","116",
                "121","126","131","136","141","146","151","156","161","166","171","176","181","186","191","196","200","276","296"]
        
        for (var i = 0; i < verbs.length; i++) {
            if (currentVerbs.indexOf(verbs[i].verbUid) == -1) {
                return true;
            }
        }
        return false;
    }

    checkIfAllVerbsAreGames(verbs){
        var currentVerbs = ["1","2","4","5","6","8","9","10","12","13","14","16","17","18","20","21","22","24","25",
                "26","28","29","30","32","33","34","36","37","38","40","41","42","44","45","46","48","49","50","52",
                "53","54","56","57","58","60","61","62","64","65","66","68","69","70","72","73","74","76","77","78","80"
                ,"81","82","84","85","86","88","89","90","92","93","94","96","100","101","105","106","110","111","115","116",
                "121","126","131","136","141","146","151","156","161","166","171","176","181","186","191","196","200","276","296"]
        
        for (var i = 0; i < verbs.length; i++) {
            if (currentVerbs.indexOf(verbs[i].verbUid) > -1) {
                return true;
            }
        }
        return false;
    }

    checkIfVerbUidAreGames(verbUid){
        var currentVerbs = ["1","2","4","5","6","8","9","10","12","13","14","16","17","18","20","21","22","24","25",
                "26","28","29","30","32","33","34","36","37","38","40","41","42","44","45","46","48","49","50","52",
                "53","54","56","57","58","60","61","62","64","65","66","68","69","70","72","73","74","76","77","78","80"
                ,"81","82","84","85","86","88","89","90","92","93","94","96","100","101","105","106","110","111","115","116",
                "121","126","131","136","141","146","151","156","161","166","171","176","181","186","191","196","200","276","296"];
        if (currentVerbs.indexOf(verbUid) > -1) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        var tempData = homeworkStore.getSelectedMassData();
        var games;
        if (this.props.data.type.indexOf("vocabs") > -1 || this.props.data.type == "custom") {
            if (this.props.data.language.hasSpeaking != "1") {
                games = this.getVocabGamesNoSpeaking();
            } else if (this.props.data.language.ietf == "hz") {
                games = this.getVocabGamesNoWriting();
            } else {
                games = this.getVocabGames();
            }
        } else if (this.props.data.type == "grammar") {
            games = this.getGrammarGames();
        } else if (this.props.data.type == "sentences") {
            games = this.getSentenceGames();
        } else if (this.props.data.type == "verbs") {
            if (this.checkIfVerbsAreGames(tempData)) {
                games = this.getVerbGames();
            } else {
                games = this.getVerbGamesSub();
            }

        } else if (this.props.data.type == "exam") {
            if (this.props.data.language.ietf == "ar") {
                games = this.getExamGamesArabic();
            } else {
                games = this.getExamGames();
            }
        }
        if (games.length == 1) {
            this.isChecked[0] = true;
        }
        this.setState({
            "games":games
        });
    }

    getGrammarGames() {
        var isExtra = true;
        var tempData = homeworkStore.getSelectedMassData();
        for (var i =0; i < tempData.length; i++) {
            if (tempData[i].other == undefined) {
                isExtra = false;
            }
        }
        if (isExtra) {
            return [
                { uid: 17 , title:2127},
                { uid: 18 , title:1018}
            ]
        } else {
            return [
                { uid: 18 , title:1018}
            ]
        }
    }

    getVocabGames() {
        return [ 
            { uid: 10 , title:12546},
            { uid: 13 , title:12117},
            { uid: 4 , title:12544},
            { uid: 6 , title:12553},
            { uid: 7 , title:12545},
            { uid: 1 , title:12543}
        ]
    }

    getVocabGamesNoWriting() {
        return [ 
            { uid: 10 , title:12546},
            { uid: 13 , title:12117},
            { uid: 4 , title:12544},
            { uid: 6 , title:12553},
            { uid: 1 , title:12543}
        ]
    }

    getVocabGamesNoSpeaking() {
        return [ 
            { uid: 10 , title:12546},
            { uid: 13 , title:12117},
            { uid: 4 , title:12544},
            { uid: 6 , title:12553},
            { uid: 7 , title:12545}
        ]
    }


    getSentenceGames() {
        var style = AccountStore.getCurriculumData().style;
        switch(style) {
            case "hodder":
            case "secondary":
            case "secondaryeal":
            case "secondarypearson":
            case "otava":
            return [
                { uid: 18 , title:1018}
            ]
            default:
            return [
                { uid: 18 , title:1018},
                { uid: 209 , title:12119}
            ]   
        }
    }

    getVerbGames() {
        return [
            { uid: 15 , title:1024},
            { uid: 16 , title:1025}
        ]
    }

    getVerbGamesSub() {
        return [
            { uid: 16 , title:1025}
        ]
    }


    getExamGames() { 
        return [
            { uid: 200 , title:12120, isSwitcher:true, skills:"reading"},
            { uid: 201 , title:12117, isSwitcher:true, skills:"reading"},
            { uid: 203 , title:12547, isSwitcher:false, skills:"reading"},
            { uid: 204 , title:12118, isSwitcher:true, skills:"listening"},
            { uid: 205 , title:12048, isSwitcher:false, skills:"listening"},
            { uid: 202 , title:12121, isSwitcher:true, skills:"listening"},
            { uid: 206 , title:12093, isSwitcher:true, skills:"writing"},
            { uid: 207 , title:12095, isSwitcher:true, skills:"speaking"},
            { uid: 208 , title:12082, isSwitcher:false, skills:"speaking"}];
    }

    getExamGamesArabic() {
        return [
            { uid: 200 , title:12120, isSwitcher:true, skills:"reading"},
            { uid: 201 , title:12117, isSwitcher:true, skills:"reading"},
            { uid: 204 , title:12118, isSwitcher:true, skills:"listening"},
            { uid: 205 , title:12048, isSwitcher:false, skills:"listening"},
            { uid: 202 , title:12121, isSwitcher:true, skills:"listening"},
            { uid: 206 , title:12093, isSwitcher:true, skills:"writing"},
            { uid: 207 , title:12095, isSwitcher:true, skills:"speaking"},
            { uid: 208 , title:12082, isSwitcher:false, skills:"speaking"}];
    }

    checkIsSelected() {
        for (var isChecked in this.isChecked){
            if (this.isChecked.hasOwnProperty(isChecked) && this.isChecked[isChecked] == true) {
                return false;
            }
        }
        return true;
    }

    addNewData(isForward) {
        var games = [];
        var verbMatcherNotSelected = true;
        for (var i =0; i < this.state.games.length; i++) {
            if (this.isChecked[i] == true) {
                if (this.isExamTrigger[i] == true) {
                    this.state.games[i].isEnglish = false;
                } else {
                    this.state.games[i].isEnglish = true;
                }
                games.push(this.state.games[i]);
                if (this.state.games[i].uid == 16) {
                    verbMatcherNotSelected = false;
                }
            }
        }
        var tempData = homeworkStore.getSelectedMassData();
        /*
        SentenceContent/grammar
        HomeworkStore.addToTemporaryStore(catalogUid);
        HomeworkStore.addToTemporaryStore(data.sentenceTranslations);
        HomeworkStore.addToTemporaryStore(currentTitle);

        verbGames
        HomeworkStore.addToTemporaryStore(data.verbUid);
        HomeworkStore.addToTemporaryStore(data2.verbTranslations);
        HomeworkStore.addToTemporaryStore(currentTitle);

        exam
        HomeworkStore.addToTemporaryStore(data.uid);
        HomeworkStore.addToTemporaryStore(data2);
        HomeworkStore.addToTemporaryStore(data.difficulty);
        */

        for (var i =0; i < tempData.length; i++) {
            var data1 = "";
            var data2 = [];
            var data3 = "";
            var newGames = games.slice(0);
            if (this.props.data.type.indexOf("vocabs") > -1 || this.props.data.type == "custom") {
                data1 = tempData[i].catalog_uid
                data3 = tempData[i].title;
            } else if (this.props.data.type == "grammar") {
                data1 = tempData[i].grammar_catalog_uid
                data3 = tempData[i].title;
            } else if (this.props.data.type == "sentences") {
                data1 = tempData[i].sentence_catalog
                data3 = tempData[i].title;
            } else if (this.props.data.type == "verbs") {
                data1 = tempData[i].verbUid
                data3 = tempData[i].title;
            } else if (this.props.data.type == "exam") {
                data1 = tempData[i].uid
                data3 = tempData[i].title;
            }
            if ((this.props.data.type == "verbs") && this.checkIfVerbUidAreGames(tempData[i].verbUid)) {
                homeworkStore.addNewTask(this.props.data.type, data1, [{ uid: 16 , title:1025}], 
                        data2, data3, tempData[i].difficulty, tempData[i].exam_catalog_uid);
            } else {
                homeworkStore.addNewTask(this.props.data.type, data1, newGames, data2, data3, tempData[i].difficulty, tempData[i].exam_catalog_uid);
            }
        }

        if (isForward) {
            this.props.data.counter++;
            this.props.forceAdvance();
        } else {
            this.props.forceBack();
        }
    }

    renderTime(time){

        function secondsToHms(d) {
            d = Number(d);
            if (d ==0) {
                return "-"
            }
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);

            if (h < 9) {
                h = "0"+h;
            }
            if (m < 9) {
                m = "0"+m;
            }
            if (s < 9) {
                s = "0"+s;
            }


            var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
            var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes") : "";
            var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

            return hDisplay+ mDisplay;
        }
        var totalChecked = 0;

        for (var isChecked in this.isChecked){
            if (this.isChecked.hasOwnProperty(isChecked) && this.isChecked[isChecked] == true) {
               totalChecked++;
            }
        }
        return secondsToHms(time+homeworkStore.getSelectedMassData().length * totalChecked*180);
    }

    render(){

        var Warning = "";

        var Question = Translation.get(12696, "Please select the vocabulary activity");

        if (this.props.data.type == "custom") {
            Question = Translation.get(12697, "Please select the activity");
        }

        if (this.props.data.type == "sentences") {
            Question = Translation.get(12698,"Please select the sentence building activity");
        } else if (this.props.data.type == "grammar") {
            Question = Translation.get(12699,"Please select the grammar activity");
        } else if (this.props.data.type == "verbs") {
            Question = Translation.get(12700,"Please select the verb activity");
            var tempData = homeworkStore.getSelectedMassData();
            if (this.checkIfVerbsAreGames(tempData) && this.checkIfAllVerbsAreGames(tempData)) {
                Warning = Translation.get(12701,"Jigsaw is not available for all selected verbs. Verb matcher will be used instead for these verbs");
            }
        }  else if (this.props.data.type == "exam") {
            Question = Translation.get(12702,"Please select the exam skill activity");
        }


        var answer = Translation.get(12703,"Please click here to add another vocabulary activity");

        if (this.props.data.type == "custom") {
            answer = Translation.get(12704,"Please click here to add another custom content activity");
        }


        if (this.props.data.type == "sentences") {
            answer = Translation.get(12705,"Please click here to add another sentence building activity");
        } else if (this.props.data.type == "grammar") {
            answer = Translation.get(12706,"Please click here to add another grammar activity");
        } else if (this.props.data.type == "verbs") {
            answer = Translation.get(12707,"Please click here to add another verb activity");
        }  else if (this.props.data.type == "exam") {
            answer = Translation.get(12708,"Please click here to add another exam activity");
        }

        var BuckButton = React.createElement(Button, {
            onClick: this.addNewData.bind(this, false),
            bsStyle:'primary',
            className:"btn-block",
            disabled:this.checkIsSelected()
        },Translation.get(12289 , "Yes") );

        var AdvanceButton = React.createElement(Button, {
            onClick: this.addNewData.bind(this, true),
            bsStyle:'primary',
            className:"btn-block",
            disabled:this.checkIsSelected()
        },Translation.get(12290 , "No") );

        return <div>
            {this.state.currentPopout}
            <Row>
                <Col md={12}>
                    <Card body>
                            <ol class="breadcrumb breadcrumb2">
                                <div style={{width:"100%"}}>
                                    <div style={{float: "left", color:"#FFFFFF", fontWeight: "bold"}}>{Question}</div>
                                    <div style={{float: "right", color:"#FFFFFF", fontWeight: "bold"}}>{Translation.get(12790, 'Estimated assignment time:')}: {this.renderTime(homeworkStore.getCurrentTime())} </div>
                                </div>
                            </ol>
                        <Row>
                            {this.view.bind(this)()}
                        </Row>
                        <h6>{Warning}</h6>
                    </Card>
                    <br/>
                    <Card body>
                        <Row>
                            <Col md={12}><b>{answer}</b></Col>
                            <br/>
                            <br/>
                            <Col md={6}>{BuckButton}</Col><Col md={6}>{AdvanceButton}</Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </div>;
    }
}


export default {
    name:function() { return Translation.get(906 , 'Settings')},
    icon:<i class="fa-2x fas fa-upload"></i>,
    title:null,
    disableButtons:true,
    onSubmit: function (done){

        done();
    },
    onBack:function(done){
        done();
    },
    component: Activity
}